var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Detail"},[_c('Empty',{attrs:{"description":"努力开发中，敬请期待..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }